import $ from 'cash-dom';

export default () => {
  const $button = $('.js-form-select');
  const $option = $('.js-change-option');

  $button.on('click', (e) => {
    const $this = $(e.currentTarget);
    const $wrap = $this.parent();

    $wrap.toggleClass('is-active');
  });

  $option.on('click', (e) => {
    const $this = $(e.currentTarget);
    const $wrap = $this.parents('.input-wrap');
    const value = $this.text(); // not so safe

    $wrap.find('.input-text').text(value);
    $wrap.find('.input')
      .val(value)
      .addClass('filled');

    $wrap.toggleClass('is-active');
  });

  const checkInput = (input) => {
    const $input = $(input);

    if ($input && $input.val().length > 0) {
      $input.addClass('filled');
    } else {
      $input.removeClass('filled');
    }
  };

  $('.input').each((index, item) => {
    checkInput(item);
  });

  $('.input').on('change', (e) => {
    checkInput(e.currentTarget);
  });
};
